module.exports = __webpack_public_path__ + "static/media/How to add a document under client file.b771d4af.png";